import { type MantineColorScheme, useMantineColorScheme } from '@mantine/core';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, useLanguageSwitch } from '@/components/LanguageSelector/LanguageSelector';
import { LedgerRow } from '@/components/Ui/LedgerRow';
import { Section } from '@/components/Ui/Section';
import { SegmentedButtons } from '@/components/Ui/SegmentedButtons';
import shared from '../AccountScreens.module.css';

export function Preferences() {
  const { t } = useTranslation();
  const { current, switchTo } = useLanguageSwitch();
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const themeLabel = useId();
  const languageId = useId();

  return (
    <Section title={t('security.preferences.title')}>
      <LedgerRow
        label={<label htmlFor={languageId}>{t('security.preferences.language')}</label>}
        value={
          <select
            id={languageId}
            className={shared.nativeInput}
            style={{ maxWidth: 260 }}
            value={current}
            onChange={(e) => void switchTo(e.currentTarget.value)}
          >
            {LANGUAGES.map((l) => (
              <option key={l.value} value={l.value}>
                {l.name}
              </option>
            ))}
          </select>
        }
      />
      <LedgerRow
        label={<span id={themeLabel}>{t('security.preferences.theme')}</span>}
        value={
          <SegmentedButtons<MantineColorScheme>
            aria-labelledby={themeLabel}
            value={colorScheme}
            onChange={setColorScheme}
            options={[
              { value: 'auto', label: t('security.preferences.themeAuto') },
              { value: 'light', label: t('security.preferences.themeLight') },
              { value: 'dark', label: t('security.preferences.themeDark') },
            ]}
          />
        }
      />
    </Section>
  );
}
